import styled, { css } from 'styled-components'
import { InputProps } from '@elamajs/ui-kit'

export const Input = styled.input<InputProps>`
  height: 50px;
  border: 1px solid #c2c7d6;
  border-radius: 5px;

  font-size: 14px !important;
  line-height: 20px;
  color: #292e3d;
  font-family: 'Navigo', Arial, Helvetica, sans-serif;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button,
  &[type='number'] {
    -webkit-appearance: none;
    -moz-appearance: textfield;
    margin: 0;
  }

  &::placeholder {
    font-family: 'Navigo', Arial, Helvetica, sans-serif;
    color: #a3abc2;
  }

  &:hover {
    border: 1px solid #c2c7d6;
    box-shadow: inset 0 0 0 1px #c2c7d6;
  }

  &:active,
  &:focus {
    border-color: #3a64f8;
    box-shadow: none;
  }

  ${({ borderless }) =>
    borderless &&
    css`
      border: none;
    `}

  ${({ hasError, errorMessage }) =>
    (hasError || errorMessage) &&
    css`
      border-color: #fa3848;
    `}
`
